import React, { useState, useEffect } from 'react';
import { Button, Modal, Alert } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
// Reducers
// utils
import { handlerErrors } from 'utils/handleErrors';
import { AnimatePresence, motion } from 'framer-motion';
import { ToastErrorCath, ToastSuccess } from '../alerts/toast';
// components
import InputTextFetchData from '../form-elements/InputTextFetchData';
import InputText from '../form-elements/InputText';
import ButtonRequest from '../buttons/ButtonRequest';

// api
import { getShippingDetails, cancelShipping } from '../../api/Api-user';

const ShippingRefundModal = ({ setIsRefundModalOpen, isRefundModalOpen, shippingToRefound, setUpdatePage }) => {
  const location = useLocation();
  const { generalData } = useSelector((state) => state.general_data);
  // console.log('generalData refound:', generalData);
  const initialShippingState = {
    company: '',
    serviceName: '',
    nameTo: '',
    depth: '',
    width: '',
    height: '',
    weight: '',
    volumetricWeight: '',
    totalWeight: '',
  };
  // - Local States
  const [shipping, setShipping] = useState(initialShippingState);
  const [shippingID, setShippingID] = useState('');
  const [requestReason, setRequestReason] = useState('');
  const [isGettingData, setIsGettingData] = useState(false);
  const [isShippingOk, setIsShippingOk] = useState(false);
  // const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isAddChargerLoader, setIsAddChargerLoader] = useState(false);
  const [requestError, seRequestError] = useState('');
  const [isRequestError, setIsRequestError] = useState(false);
  const [deleteCount, setDeleteCount] = useState(0);

  const updateField = (data, validation) => {
    // Eliminar espacios y caracteres especiales
    const cleanedData = data.replace(/[^a-zA-Z0-9 ]/g, '').trim();
    if (data === '' || validation.test(cleanedData)) {
      setShippingID(cleanedData);
    }
  };
  const updateTextField = (data, validation) => {
    if (data === '' || validation.test(data)) {
      setRequestReason(data);
    }
  };
  const closeModal = () => {
    setIsRefundModalOpen(false);
    setShipping(initialShippingState);
    setIsShippingOk(false);
    seRequestError('');
    setIsRequestError(false);
    setShippingID('');
    setRequestReason('');
  };
  const handlerShippingRefund = async () => {
    setIsAddChargerLoader(true);
    try {
      if (shippingID && requestReason) {
        setIsAddChargerLoader(true);
        // setTimeout(() => {
        //   setIsAddChargerLoader(false);
        // }, 2000);
        const response = await cancelShipping(shippingID, requestReason);
        // console.log('reembolso response:', response);
        if (response.success !== undefined) {
          setIsAddChargerLoader(false);
          //  update the page
          setUpdatePage((prev) => !prev);
          ToastSuccess(response.message);
          closeModal();
        }
      } else {
        // throw error shippingID && requestReason are required
        ToastErrorCath('Error: Por favor, completa todos los campos requeridos. Ambos datos son necesarios para continuar.');
      }
    } catch (error) {
      // ToastErrorCath();
      handlerErrors(error);
    } finally {
      setIsAddChargerLoader(false);
    }
  };
  // - Data Validatxion

  const getShippingData = async (param) => {
    let inputValue = '';
    let key = null;

    if (typeof param === 'string') {
      // Llamada manual desde useEffect con un string
      inputValue = param;
    } else if (param?.target?.value) {
      // Llamada desde evento input
      inputValue = param.target.value;
      key = param.nativeEvent?.inputType;
    }

    const cleanedInputValue = inputValue.replace(/[^a-zA-Z0-9 ]/g, '').trim();
    setIsGettingData(true);
    // console.log('valores antes de actualizar', pickup);
    // If the user is deleting
    if (key === 'deleteContentBackward' || key === 'deleteContentForward') {
      setDeleteCount((prevCount) => prevCount + 1);
      if (deleteCount >= 5) {
        // remove all functionality if the user deletes more than 2
        //  characters to avoid massive 406 errors
        setIsGettingData(false);
        setIsShippingOk(false);
        seRequestError('');
        setIsRequestError(false);
        return;
      }
    } else {
      // Reset the counter if the user is typing
      setDeleteCount(0);
    }
    try {
      if (inputValue.length > 5) {
        seRequestError('');
        setIsRequestError(false);
        // Retrasar la solicitud por 1 segundo
        // await new Promise((resolve) => setTimeout(resolve, 1000));
        const response = await getShippingDetails(cleanedInputValue);
        // console.log('getShipping response:', response);
        if (response.shipping_code !== undefined) {
          seRequestError('');
          setIsRequestError(false);
          setIsShippingOk(true); // to show div data
          // Set states with data from firebase Start
          setShipping({
            ...response,
            // id: cleanedInputValue,
            serviceName: response.shipping_code,
            company: response.shipping_company,
            nameTo: response.address_to.name,
            depth: response.parcel.depth,
            width: response.parcel.width,
            height: response.parcel.height,
            weight: response.parcel.weight,
            volumetricWeight: response.parcel.volumetric_weight,
            totalWeight: response.parcel.total_weight,
          });
        } else if (response.error) {
          const firstKey = Object.keys(response.error)[0];
          setIsRequestError(true);
          setIsShippingOk(false);
          seRequestError(response.error[firstKey]);
          setShipping(initialShippingState);
        }
      } else {
        // if shippingId is < 5 or empty clean any error and shipping data
        setIsRequestError(false);
        seRequestError('');
        setIsShippingOk(false);
        setShipping(initialShippingState);
      }
    } catch {
      setIsRequestError(true);
      setIsShippingOk(false);
      seRequestError('Error: Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo. (catch error)');
    } finally {
      setIsGettingData(false);
    }
  };
  useEffect(() => {
    // set the value with the value that comes from history shipping
    if (location.pathname === '/envios/historial') {
      setShippingID(generalData.fields.shippingIdToReport);
      // console.log('shippingToRefound', shippingToRefound);
      getShippingData(generalData.fields.shippingIdToReport);
    }
  }, [generalData]);
  // console.log('envio:', shipping);
  return (
    <Modal show={isRefundModalOpen} onHide={closeModal}>
      <Modal.Header closeButton>
        <Modal.Title>Solicitud de Reembolso</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-infox pt-2">
        <div className={`bg-infox text-centerx ${isShippingOk ? 'visible ' : 'invisible'}`} style={{ minHeight: '36px', position: 'relative', top: '10px' }}>
          <h5 className="text-primary mb-0">{shipping?.serviceName}</h5>
          <div className="text-medium mb-0 text-muted text-truncate">{`${shipping?.nameTo}`}</div>
        </div>
        <>
          <InputTextFetchData
            icon="shipping"
            placeholder="ID Envío"
            value={shippingID}
            setField={updateField} // actualiza su value debe ser una funcion que primero valide
            isRequired="false"
            isError={isRequestError}
            error={requestError}
            setValues={getShippingData} // funcion que realiza la peticion
            isLoading={isGettingData}
            fieldName="shippingId" // este no deberia setear nungun input su respuesta de la peticion si
            validation={/^[A-Z0-9]+$/i}
          />
          <div className="mt-2">
            <InputText
              icon="edit-square"
              placeholder="Motivo por el que no se uso la guía (requerido)"
              value={requestReason}
              // isRequired
              fieldName="requestReason"
              setField={updateTextField}
            />
          </div>
        </>
        {/* <hr className="mt-3" /> */}
        <div className="info-important-container mx-auto mt-5 mb-2" style={{ maxWidth: '800px' }}>
          {shipping?.cancellation_warning_refund && (
            <div className="text-primary mb-2 text-center pre-wrap">{shipping?.cancellation_warning_refund?.toUpperCase()}</div>
          )}
          {shipping?.cancellation_penalty_shipping_used && (
            <AnimatePresence>
              <motion.div key="custom-alert" initial="hidden" animate="visible" exit="exit" transition={{ duration: 0.4 }}>
                <Alert className="mb-2 mt-2 text-center" variant="warning">
                  <span role="img" aria-label="estrella">
                    ⚠️
                  </span>{' '}
                  Para este servicio, si cancelas la guía y luego decides utilizarla, se aplicará un cargo de
                  <strong> ${shipping?.cancellation_penalty_shipping_used}</strong> por el proceso de cancelación.
                </Alert>
              </motion.div>
            </AnimatePresence>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="d-flex flex-wrap justify-content-end bg-warningd">
          <Button variant="outline-primary" style={{ height: '36px' }} className="w-auto me-2 mb-2" onClick={closeModal}>
            Cancelar
          </Button>
          <ButtonRequest
            title="Enviar Solicitud"
            titleLoading="Enviar Solicitud"
            handlerFn={handlerShippingRefund}
            isButtonDisabled={isAddChargerLoader}
            isLoading={isAddChargerLoader}
          />
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ShippingRefundModal;
